import React from 'react';

const NasAcademyFlatIcon = () => {
  return (
    <svg width="18" height="18" fill="none" viewBox="0 0 18 18">
      <path
        fill="#fff"
        d="M2.766 10.175A1.762 1.762 0 115.26 7.682l4.987 4.986a1.762 1.762 0 11-2.494 2.492l-4.987-4.985z"
      ></path>
      <path
        fill="#fff"
        d="M10.247 15.16a1.764 1.764 0 01-2.494-2.492l4.987-4.986a1.764 1.764 0 012.494 2.493l-4.987 4.985zM8.996 6.104a1.927 1.927 0 100-3.855 1.927 1.927 0 000 3.855z"
      ></path>
    </svg>
  );
};

export default NasAcademyFlatIcon;
